<script>
import { mdiCamera } from '@mdi/js'

export default {
  name: 'NewGallery',
  data() {
    return {
      fileIcon: mdiCamera,
      galerieForm: {
        type: '',
        type_code: '',
        images: [],
      },
      galleryAllType: [
        {
          label:"Studio americain",
          code:"stdio-usa"
        },
        {
          label:"Appartement 2 pièces meublé",
          code:"appt-two-pieces"
        },
        {
          label:"Appartement 3 pièces meublé VIP",
          code:"appt-three-pieces-vip"
        },
        {
          label:"Loisir",
          code:"hobbies"
        },
        {
          label:"Événementielle",
          code:"event"
        },
      ],
    }
  },
  methods: {
    newGallery(formDatas) {
      console.warn(formDatas)
    },
  },
}
</script>

<template>
<div>
  <v-row>
    <v-col
        cols="12"
        md="12"
    >
            <span
                class="text-lg-h5  mb-4"
                style="justify-content: center; display: flex;"
            >
              Nouveau type de galérie
            </span>
    </v-col>
  </v-row>
  <v-form
      class="multi-col-validation"
      style="margin-top:1rem; margin-left: 1rem; margin-bottom: 1.5rem;"
      @submit.prevent="newGallery($event.target)"
  >
    <v-row>
      <v-col
          cols="12"
          md="6"
      >
        <v-text-field
            v-model="galerieForm.type"
            dense
            hide-details
            name="type"
            label="Libellé"
            outlined
            required
            placeholder="Désignation de la galérie"
        ></v-text-field>
      </v-col>

      <v-col
          cols="12"
          md="6"
      >
        <v-select
            v-model="galerieForm.type_code"
            dense
            required
            :items="galleryAllType"
            name="type_code"
            :item-text="'label'"
            :item-value="'code'"
            label="Type de Galérie"
            outlined
        ></v-select>
      </v-col>
    </v-row>
    <v-row>
      <v-col
          cols="12"
          md="6"
      >
        <v-file-input
            v-model="galerieForm.images"
            dense
            required
            :prepend-icon="fileIcon"
            name="images[]"
            type="file"
            multiple
            accept="image/png, image/jpeg, image/bmp"
            hide-details
            label="Images de la galérie"
            outlined
            placeholder="Sélectionner les photos de cette galérie"
        >
          <template #selection="{ text }">
            <v-chip
                small
                label
                color="primary"
            >
              {{ text }}
            </v-chip>
          </template>
        </v-file-input>
      </v-col>
    </v-row>
  </v-form>
</div>
</template>

<style scoped>

</style>